const COORD_PAIR = /^-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?$/;

export function parseCoordinats(value) {
  if (value == null || String(value).trim() === "") {
    return null;
  }
  const trimmed = String(value).trim();
  if (!COORD_PAIR.test(trimmed)) {
    return null;
  }
  const [latRaw, lonRaw] = trimmed.split(",");
  const lat = Number.parseFloat(latRaw.trim());
  const lon = Number.parseFloat(lonRaw.trim());
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return null;
  }
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) {
    return null;
  }
  return { lat, lon };
}

export function formatCoordinatsForApi(value) {
  if (value == null || String(value).trim() === "") {
    return null;
  }
  return String(value).trim();
}

export function formatOptionalProductionField(value) {
  return formatCoordinatsForApi(value);
}

export const PRODUCTION_NAME_REQUIRED_MESSAGE =
  "Введите название площадки";

export function isValidCoordinatsInput(value) {
  if (value == null || String(value).trim() === "") {
    return true;
  }
  return parseCoordinats(value) !== null;
}

export const COORDINATS_FORMAT_MESSAGE =
  "Неверный формат координат. Пример: 57.629026, 39.854530";
